"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = watchers;
var _effects = require("redux-saga/effects");
var _sagas = require("../../../astercore/auth/login/redux/sagas");
var _utils = require("../../../common/utils/utils");
var api = _interopRequireWildcard(require("../api/api"));
var actions = _interopRequireWildcard(require("./actions"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function* getMyOrderJsonAPI(params) {
  try {
    var _params$data$params;
    const {
      showLoader = true,
      ...rest
    } = (_params$data$params = params.data.params) !== null && _params$data$params !== void 0 ? _params$data$params : {};
    if ((0, _utils.isMobile)() && showLoader || !(0, _utils.isMobile)()) {
      yield (0, _effects.put)(actions.GET_MY_ORDER_JSON_API.request());
    }
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.getMyOrderJson, rest, tokenData);
    yield (0, _effects.put)(actions.GET_MY_ORDER_JSON_API.success(mainResponse));
    params.data.onSuccess(mainResponse);
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.GET_MY_ORDER_JSON_API.failure(err));
    if (params.data && params.data.onFailure) {
      params.data.onFailure(err);
    }
  }
}
function* getOrderDetailsAPI(request) {
  try {
    const {
      onSuccess,
      params
    } = request.data;
    yield (0, _effects.put)(actions.GET_ORDER_DETAILS_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.getOrderDetails, params, tokenData);
    yield (0, _effects.put)(actions.GET_ORDER_DETAILS_API.success(mainResponse));
    if (onSuccess) {
      onSuccess(mainResponse || {});
    }
    return mainResponse;
  } catch (err) {
    var _request$data;
    yield (0, _effects.put)(actions.GET_ORDER_DETAILS_API.failure(err));
    if (request !== null && request !== void 0 && request.data && request !== null && request !== void 0 && (_request$data = request.data) !== null && _request$data !== void 0 && _request$data.onFailure) {
      request.data.onFailure(err);
    }
  }
}
function* getMyInStoreOrderAPI(params) {
  try {
    yield (0, _effects.put)(actions.GET_MY_INSTORE_ORDER_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.getInStoreOrder, params.data.params, tokenData);
    yield (0, _effects.put)(actions.GET_MY_INSTORE_ORDER_API.success(mainResponse));
    params.data.onSuccess(mainResponse);
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.GET_MY_INSTORE_ORDER_API.failure(err));
    if (params.data && params.data.onFailure) {
      params.data.onFailure(err);
    }
  }
}
function* getInStoreOrderDetailsAPI(request) {
  try {
    const {
      onSuccess,
      params
    } = request.data;
    yield (0, _effects.put)(actions.GET_INSTORE_ORDER_DETAILS_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.getInStoreOrderDetails, params, tokenData);
    yield (0, _effects.put)(actions.GET_INSTORE_ORDER_DETAILS_API.success(mainResponse));
    if (onSuccess) {
      var _mainResponse$data;
      onSuccess((mainResponse === null || mainResponse === void 0 || (_mainResponse$data = mainResponse.data) === null || _mainResponse$data === void 0 ? void 0 : _mainResponse$data.orders) || {});
    }
    return mainResponse;
  } catch (err) {
    var _request$data2;
    yield (0, _effects.put)(actions.GET_INSTORE_ORDER_DETAILS_API.failure(err));
    if (request !== null && request !== void 0 && request.data && request !== null && request !== void 0 && (_request$data2 = request.data) !== null && _request$data2 !== void 0 && _request$data2.onFailure) {
      request.data.onFailure(err);
    }
  }
}
function* getPrescriptionOrderDetailsAPI(request) {
  try {
    const {
      onSuccess,
      params
    } = request.data;
    yield (0, _effects.put)(actions.GET_PRESCRIPTION_ORDER_DETAILS_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.getPrescriptionOrderDetails, params, tokenData);
    yield (0, _effects.put)(actions.GET_PRESCRIPTION_ORDER_DETAILS_API.success(mainResponse));
    if (onSuccess) {
      onSuccess(mainResponse || {});
    }
    return mainResponse;
  } catch (err) {
    var _request$data3;
    yield (0, _effects.put)(actions.GET_PRESCRIPTION_ORDER_DETAILS_API.failure(err));
    if (request !== null && request !== void 0 && request.data && request !== null && request !== void 0 && (_request$data3 = request.data) !== null && _request$data3 !== void 0 && _request$data3.onFailure) {
      request.data.onFailure(err);
    }
  }
}
function* cancelOrderAPI(request) {
  try {
    var _request$data4;
    const {
      onSuccess
    } = request.data;
    yield (0, _effects.put)(actions.CANCEL_ORDER_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.cancelOrder, request === null || request === void 0 || (_request$data4 = request.data) === null || _request$data4 === void 0 ? void 0 : _request$data4.data, tokenData);
    yield (0, _effects.put)(actions.CANCEL_ORDER_API.success(mainResponse));
    if (onSuccess) {
      onSuccess(mainResponse === null || mainResponse === void 0 ? void 0 : mainResponse.data);
    }
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.CANCEL_ORDER_API.failure(err));
    if (request.data && request.data.onFailure) {
      request.data.onFailure(err);
    }
  }
}
function* mergeCartAPI(request) {
  try {
    var _request$data5, _request$data6;
    yield (0, _effects.put)(actions.MERGE_CART_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.mergeCart, request === null || request === void 0 || (_request$data5 = request.data) === null || _request$data5 === void 0 ? void 0 : _request$data5.params, tokenData);
    yield (0, _effects.put)(actions.MERGE_CART_API.success(mainResponse));
    if (request !== null && request !== void 0 && request.data && request !== null && request !== void 0 && (_request$data6 = request.data) !== null && _request$data6 !== void 0 && _request$data6.onSuccess) {
      request.data.onSuccess(mainResponse);
    }
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.MERGE_CART_API.failure(err));
    if (request.data && request.data.onFailure) {
      request.data.onFailure(err);
    }
  }
}
function* returnItem(params) {
  try {
    yield (0, _effects.put)(actions.RETURN_ITEM_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.returnItem, params.data.params.body, tokenData);
    yield (0, _effects.put)(actions.RETURN_ITEM_API.success(mainResponse));
    params.data.onSuccess(mainResponse);
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.RETURN_ITEM_API.failure(err));
    if (params.data && params.data.onFailure) {
      params.data.onFailure(err);
    }
  }
}
function* downloadInvoiceAPI(params) {
  try {
    var _params$data;
    yield (0, _effects.put)(actions.DOWNLOAD_INVOICE_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.downloadInvoice, params.data.params.orderId, tokenData);
    yield (0, _effects.put)(actions.DOWNLOAD_INVOICE_API.success(mainResponse));
    params === null || params === void 0 || (_params$data = params.data) === null || _params$data === void 0 || _params$data.onSuccess(mainResponse);
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.DOWNLOAD_INVOICE_API.failure(err));
    if (params.data && params.data.onFailure) {
      params.data.onFailure(err);
    }
  }
}
function* newMergeCartAPI(request) {
  try {
    var _request$data7, _request$data8;
    yield (0, _effects.put)(actions.NEW_MERGE_CART_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.newMergeCart, request === null || request === void 0 || (_request$data7 = request.data) === null || _request$data7 === void 0 ? void 0 : _request$data7.params, tokenData);
    yield (0, _effects.put)(actions.NEW_MERGE_CART_API.success(mainResponse));
    if (request !== null && request !== void 0 && request.data && request !== null && request !== void 0 && (_request$data8 = request.data) !== null && _request$data8 !== void 0 && _request$data8.onSuccess) {
      request.data.onSuccess(mainResponse);
    }
    return mainResponse;
  } catch (err) {
    var _request$data9;
    yield (0, _effects.put)(actions.NEW_MERGE_CART_API.failure(err));
    if (request !== null && request !== void 0 && request.data && request !== null && request !== void 0 && (_request$data9 = request.data) !== null && _request$data9 !== void 0 && _request$data9.onFailure) {
      request.data.onFailure(err);
    }
  }
}
function* getPackageTrackingInfoAPI(request) {
  try {
    const {
      onSuccess,
      params,
      showLoader = true
    } = request.data;
    if (_utils.isMobile && showLoader || !_utils.isMobile) {
      yield (0, _effects.put)(actions.TRACK_NOW_API.request());
    }
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.getPackageTrackingInfo, params, tokenData);
    yield (0, _effects.put)(actions.TRACK_NOW_API.success(mainResponse));
    if (onSuccess) {
      onSuccess((mainResponse === null || mainResponse === void 0 ? void 0 : mainResponse.data[0]) || {});
    }
    return mainResponse;
  } catch (err) {
    var _request$data10;
    yield (0, _effects.put)(actions.TRACK_NOW_API.failure(err));
    if (request !== null && request !== void 0 && request.data && request !== null && request !== void 0 && (_request$data10 = request.data) !== null && _request$data10 !== void 0 && _request$data10.onFailure) {
      request.data.onFailure(err);
    }
  }
}
function* cancelMergeCartAPI(request) {
  try {
    var _request$data11, _request$data12;
    yield (0, _effects.put)(actions.CANCEL_MERGE_CART_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.cancelMergeCart, request === null || request === void 0 || (_request$data11 = request.data) === null || _request$data11 === void 0 ? void 0 : _request$data11.params, tokenData);
    yield (0, _effects.put)(actions.CANCEL_MERGE_CART_API.success(mainResponse));
    if (request !== null && request !== void 0 && request.data && request !== null && request !== void 0 && (_request$data12 = request.data) !== null && _request$data12 !== void 0 && _request$data12.onSuccess) {
      request.data.onSuccess(mainResponse);
    }
    return mainResponse;
  } catch (err) {
    var _request$data13;
    yield (0, _effects.put)(actions.CANCEL_MERGE_CART_API.failure(err));
    if (request !== null && request !== void 0 && request.data && request !== null && request !== void 0 && (_request$data13 = request.data) !== null && _request$data13 !== void 0 && _request$data13.onFailure) {
      request.data.onFailure(err);
    }
  }
}
function* reorderAPI(request) {
  try {
    var _request$data14;
    yield (0, _effects.put)(actions.REORDER_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.reorder, request.data.params, tokenData);
    yield (0, _effects.put)(actions.REORDER_API.success(mainResponse));
    if (request !== null && request !== void 0 && request.data && request !== null && request !== void 0 && (_request$data14 = request.data) !== null && _request$data14 !== void 0 && _request$data14.onSuccess) {
      request.data.onSuccess(mainResponse);
    }
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.REORDER_API.failure(err));
    if (request.data && request.data.onFailure) {
      request.data.onFailure(err);
    }
  }
}
function* getOrdersByShipment(request) {
  try {
    var _request$data15;
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.getOrdersByShipment, tokenData);
    if (request !== null && request !== void 0 && request.data && request !== null && request !== void 0 && (_request$data15 = request.data) !== null && _request$data15 !== void 0 && _request$data15.onSuccess) {
      request.data.onSuccess(mainResponse);
    }
    return mainResponse;
  } catch (err) {
    if (request.data && request.data.onFailure) {
      request.data.onFailure(err);
    }
  }
}
function* createReturnItem(params) {
  try {
    var _params$data2;
    yield (0, _effects.put)(actions.CREATE_RETURN_ITEM_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.createReturnItem, params.data.params.body, tokenData);
    yield (0, _effects.put)(actions.CREATE_RETURN_ITEM_API.success(mainResponse));
    if (params !== null && params !== void 0 && params.data && params !== null && params !== void 0 && (_params$data2 = params.data) !== null && _params$data2 !== void 0 && _params$data2.onSuccess) {
      params.data.onSuccess(mainResponse);
    }
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.CREATE_RETURN_ITEM_API.failure(err));
    if (params.data && params.data.onFailure) {
      params.data.onFailure(err);
    }
  }
}
function* getReturnStatus(params) {
  try {
    var _params$data3;
    yield (0, _effects.put)(actions.GET_RETURN_STATUS_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.getReturnStatus, params.data.params, tokenData);
    yield (0, _effects.put)(actions.GET_RETURN_STATUS_API.success(mainResponse));
    if (params !== null && params !== void 0 && params.data && params !== null && params !== void 0 && (_params$data3 = params.data) !== null && _params$data3 !== void 0 && _params$data3.onSuccess) {
      params.data.onSuccess(mainResponse);
    }
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.GET_RETURN_STATUS_API.failure(err));
    if (params.data && params.data.onFailure) {
      params.data.onFailure(err);
    }
  }
}
function* getReturnDetails(params) {
  try {
    var _params$data4;
    yield (0, _effects.put)(actions.GET_RETURN_DETAILS_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.getReturnDetails, params.data.params, tokenData);
    yield (0, _effects.put)(actions.GET_RETURN_DETAILS_API.success(mainResponse));
    if (params !== null && params !== void 0 && params.data && params !== null && params !== void 0 && (_params$data4 = params.data) !== null && _params$data4 !== void 0 && _params$data4.onSuccess) {
      params.data.onSuccess(mainResponse);
    }
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.GET_RETURN_DETAILS_API.failure(err));
    if (params.data && params.data.onFailure) {
      params.data.onFailure(err);
    }
  }
}
function* watchers() {
  yield (0, _effects.takeLatest)(actions.GET_MY_ORDER_JSON, getMyOrderJsonAPI);
  yield (0, _effects.takeLatest)(actions.GET_ORDER_DETAILS, getOrderDetailsAPI);
  yield (0, _effects.takeLatest)(actions.GET_MY_INSTORE_ORDER, getMyInStoreOrderAPI);
  yield (0, _effects.takeLatest)(actions.GET_INSTORE_ORDER_DETAILS, getInStoreOrderDetailsAPI);
  yield (0, _effects.takeLatest)(actions.TRACK_NOW, getPackageTrackingInfoAPI);
  yield (0, _effects.takeLatest)(actions.DOWNLOAD_INVOICE, downloadInvoiceAPI);
  yield (0, _effects.takeLatest)(actions.RETURN_ITEM, returnItem);
  yield (0, _effects.takeLatest)(actions.CANCEL_ORDER, cancelOrderAPI);
  yield (0, _effects.takeLatest)(actions.MERGE_CART, mergeCartAPI);
  yield (0, _effects.takeLatest)(actions.NEW_MERGE_CART, newMergeCartAPI);
  yield (0, _effects.takeLatest)(actions.CANCEL_MERGE_CART, cancelMergeCartAPI);
  yield (0, _effects.takeLatest)(actions.REORDER, reorderAPI);
  yield (0, _effects.takeLatest)(actions.GET_ORDERS_BY_SHIPMENT, getOrdersByShipment);
  yield (0, _effects.takeLatest)(actions.GET_PRESCRIPTION_ORDER_DETAILS, getPrescriptionOrderDetailsAPI);
  yield (0, _effects.takeLatest)(actions.CREATE_RETURN_ITEM, createReturnItem);
  yield (0, _effects.takeLatest)(actions.GET_RETURN_STATUS, getReturnStatus);
  yield (0, _effects.takeLatest)(actions.GET_RETURN_DETAILS, getReturnDetails);
}